(function ($) {
  Drupal.behaviors.ehThewinkHpRedesignSocialShareV1 = {
    attach: function (context, settings) {
      var formatter = $('.eh-thewink-hp-redesign-social-share-v1', context);

      formatter.once('eh-thewink-hp-redesign-social-share').each(function () {
        var thisFormatter = $(this);
        var url = window.location.hostname;
        var $parent = thisFormatter.closest('.container-inner');
        var articleUrl = $parent.prev().find('a').attr('href');
        var shareUrl = encodeURI(window.location.protocol) + '//' + encodeURI(url) + '/' + encodeURI(articleUrl);
        var title = $parent.prev().find('.article-title').text();

        title = $.trim(title).replace('"', '');
        title = title.replace('"', '');
        var img = $parent.prev().find('.article-img').attr('src');

        thisFormatter.find('.social_icons:last').addClass('last-icon');

        // Build share URLs
        var twitter_url = 'http://twitter.com/intent/tweet?url=' + encodeURI(shareUrl) + '&amp;text=' + encodeURI(title);
        var facebook_url = 'http://www.facebook.com/sharer.php?u=' + encodeURI(shareUrl) + '&amp;t=' + encodeURI(title);
        var pinterest_url = 'http://pinterest.com/pin/create/button/?url=' + encodeURI(shareUrl) + '&amp;media=' + encodeURI(window.location.protocol) + '//' + encodeURI(url) + img + '&amp;description=' + title;
        // FE-1235
        var weibo_url = 'http://service.weibo.com/share/share.php?language=zh_cn&url=' + encodeURI(shareUrl) + '&amp;t=' + encodeURI(title);

        // Append share URLs to document
        thisFormatter.find('.social_share_links .facebook a').attr('href', facebook_url);
        thisFormatter.find('.social_share_links .twitter a').attr('href', twitter_url);
        thisFormatter.find('.social_share_links .pinterest a').attr('href', pinterest_url);
        // FE-1235
        thisFormatter.find('.social_share_links .weibo a').attr('href', weibo_url);

        // Social share links
        var $shareLink = thisFormatter.find('.social_share_links .eh-social-share__link');

        $shareLink.once('eh-social-share-links').on('click', function (e) {
          if (!e) {
            var e = window.event;
          }
          e.cancelBubble = true;
          if (e.stopPropagation) {
            e.stopPropagation();
          }
          e.preventDefault();

          var width = 800;
          var height = 450;
          var openUrl = $(this).attr('href');
          // Allow for borders.
          var leftPosition = (window.screen.width / 2) - ((width / 2) + 10);
          // Allow for title and status bars.
          var topPosition = (window.screen.height / 2) - ((height / 2) + 50);
          var windowFeatures = 'status=no,height=' + height + ',width=' + width;

          windowFeatures += ',resizable=yes,left=' + leftPosition + ',top=' + topPosition;
          windowFeatures += ',screenX=' + leftPosition + ',screenY=' + topPosition;
          windowFeatures += ',toolbar=no,menubar=no,scrollbars=no,location=no,directories=no';

          if ($(this).parent().hasClass('mail')) {
            window.location.href = openUrl;
          } else {
            var newWin = window.open(openUrl, 'sharer', windowFeatures);
          }
        });

        // Lazyload
        site.util.lazyLoaded(thisFormatter);
      });
    }
  };
})(jQuery);
